var _defs, _g, _rect, _g2, _defs2, _g3, _g4, _defs3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 180,
    height: 150,
    viewBox: "0 0 250 250",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 92,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fa71cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b59b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 93,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 94,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0064d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1cb0f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 95,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f00978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f51b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 96,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7873f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ec77ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 97,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e14fad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 98,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2af598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 99,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00b140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 100,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d51007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 102,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a2b6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c3483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 103,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ac5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eea2a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 104,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ecbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007adf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 105,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b88746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fdf5a6"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "iconblsvg-g iconsvg",
    transform: "translate(67.09937286376953,103.75893020629883)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "tp-name",
    transform: "translate(0,0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1A1919",
    transform: "translate(0, 2.151068687438965)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57 0L1.57-20.11 18.35-20.11Q19.75-20.11 20.72-19.13 21.7-18.15 21.7-16.75L21.7-16.75 21.7-10.85Q21.7-9.45 20.72-8.47 19.75-7.5 18.35-7.5L18.35-7.5 4.92-7.5Q4.67-7.5 3.83-7.61L3.83-7.61 3.83 0 1.57 0ZM19.44-10.85L19.44-10.85 19.44-16.75Q19.44-17.2 19.12-17.52 18.79-17.84 18.35-17.84L18.35-17.84 4.92-17.84Q4.47-17.84 4.15-17.52 3.83-17.2 3.83-16.75L3.83-16.75 3.83-10.85Q3.83-10.4 4.15-10.1 4.47-9.79 4.92-9.79L4.92-9.79 18.35-9.79Q18.79-9.79 19.12-10.1 19.44-10.4 19.44-10.85ZM26.96-16.22L26.96-16.22 36.08-16.22 36.08-13.93 26.96-13.93Q26.51-13.93 26.19-13.61 25.87-13.28 25.87-12.84L25.87-12.84 25.87 0 23.58 0 23.58-12.84Q23.58-14.24 24.57-15.23 25.56-16.22 26.96-16.22ZM41.11-16.22L41.11-16.22 50.85-16.22Q52.27-16.22 53.26-15.23 54.26-14.24 54.26-12.84L54.26-12.84 54.26-3.38Q54.26-1.99 53.26-0.99 52.27 0 50.85 0L50.85 0 41.11 0Q39.71 0 38.72-0.99 37.73-1.99 37.73-3.38L37.73-3.38 37.73-12.84Q37.73-14.24 38.72-15.23 39.71-16.22 41.11-16.22ZM50.85-13.93L50.85-13.93 41.11-13.93Q40.67-13.93 40.34-13.61 40.02-13.28 40.02-12.84L40.02-12.84 40.02-3.38Q40.02-2.94 40.34-2.61 40.67-2.29 41.11-2.29L41.11-2.29 50.85-2.29Q51.29-2.29 51.61-2.61 51.94-2.94 51.94-3.38L51.94-3.38 51.94-12.84Q51.94-13.28 51.61-13.61 51.29-13.93 50.85-13.93Z",
    transform: "translate(-1.5699999332427979, 21.540000915527344)",
    strokeWidth: 0.2,
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(55.689998626708984, 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "imagesvg"
  }, /*#__PURE__*/React.createElement("g", null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#1A1919",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 25.76125208203853,
    height: 25.84213797389683,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    filter: "url(#colors6107157738)",
    x: 0,
    y: 0,
    width: 25.76125208203853,
    height: 25.84213797389683,
    filtersec: "colorsf4686442246",
    className: "image-svg-svg primary",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0.10000000149011612 0 31.899999618530273 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.1,20.3V32h6V18.8C3.7,19.4,3.1,19.6,0.1,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,17.9V32h6V15.4C12.1,16.6,11.4,16.9,8.7,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3,13.9V32h6V9.9C20.9,11.7,20.1,12.3,17.3,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,7.4V32h6V0C29.7,3.2,28.8,4.6,26,7.4z"
  }))))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "colors6107157738"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.203125  0 0 0 0 0.51953125  0 0 0 0 0.16796875  0 0 0 1 0",
    className: "icon-feColorMatrix "
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsf4686442246"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsb986549793"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "#171717",
    fill: "#000000",
    transform: "translate(84.45125198364258, 2.151068687438965)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57 0L1.57-20.11 18.35-20.11Q19.75-20.11 20.72-19.13 21.7-18.15 21.7-16.75L21.7-16.75 21.7-10.85Q21.7-9.45 20.72-8.47 19.75-7.5 18.35-7.5L18.35-7.5 4.92-7.5Q4.67-7.5 3.83-7.61L3.83-7.61 3.83 0 1.57 0ZM19.44-10.85L19.44-10.85 19.44-16.75Q19.44-17.2 19.12-17.52 18.79-17.84 18.35-17.84L18.35-17.84 4.92-17.84Q4.47-17.84 4.15-17.52 3.83-17.2 3.83-16.75L3.83-16.75 3.83-10.85Q3.83-10.4 4.15-10.1 4.47-9.79 4.92-9.79L4.92-9.79 18.35-9.79Q18.79-9.79 19.12-10.1 19.44-10.4 19.44-10.85ZM26.93-16.22L36.67-16.22Q38.09-16.22 39.08-15.23 40.08-14.24 40.08-12.84L40.08-12.84 40.08-6.96 25.84-6.96 25.84-3.38Q25.84-2.94 26.16-2.61 26.49-2.29 26.93-2.29L26.93-2.29 40.08-2.29 40.08 0 26.93 0Q25.53 0 24.54-0.99 23.55-1.99 23.55-3.38L23.55-3.38 23.55-12.84Q23.55-14.24 24.54-15.23 25.53-16.22 26.93-16.22L26.93-16.22ZM25.84-12.84L25.84-9.26 37.76-9.26 37.76-12.84Q37.76-13.28 37.43-13.61 37.11-13.93 36.67-13.93L36.67-13.93 26.93-13.93Q26.49-13.93 26.16-13.61 25.84-13.28 25.84-12.84L25.84-12.84ZM42.99-16.22L56.13-16.22Q57.53-16.22 58.52-15.23 59.52-14.24 59.52-12.84L59.52-12.84 59.52 0 57.22 0 57.22-12.84Q57.22-13.28 56.9-13.61 56.58-13.93 56.13-13.93L56.13-13.93 46.4-13.93Q45.95-13.93 45.62-13.61 45.28-13.28 45.28-12.84L45.28-12.84 45.28 0 42.99 0 42.99-16.22ZM78.81-12.84L78.81-12.84 78.81-12.61 76.49-12.61 76.49-12.84Q76.49-13.28 76.17-13.61 75.85-13.93 75.4-13.93L75.4-13.93 65.67-13.93Q65.22-13.93 64.9-13.61 64.58-13.28 64.58-12.84L64.58-12.84 64.58-10.35Q64.58-9.9 64.9-9.58 65.22-9.26 65.67-9.26L65.67-9.26 75.4-9.26Q76.83-9.26 77.82-8.26 78.81-7.27 78.81-5.87L78.81-5.87 78.81-3.38Q78.81-1.99 77.82-0.99 76.83 0 75.4 0L75.4 0 65.67 0Q64.27 0 63.28-0.99 62.28-1.99 62.28-3.38L62.28-3.38 62.28-3.61 64.58-3.61 64.58-3.38Q64.58-2.94 64.9-2.61 65.22-2.29 65.67-2.29L65.67-2.29 75.4-2.29Q75.85-2.29 76.17-2.61 76.49-2.94 76.49-3.38L76.49-3.38 76.49-5.87Q76.49-6.32 76.17-6.64 75.85-6.96 75.4-6.96L75.4-6.96 65.67-6.96Q64.27-6.96 63.28-7.96 62.28-8.95 62.28-10.35L62.28-10.35 62.28-12.84Q62.28-14.24 63.28-15.23 64.27-16.22 65.67-16.22L65.67-16.22 75.4-16.22Q76.83-16.22 77.82-15.23 78.81-14.24 78.81-12.84ZM83.88 0L81.58 0 81.58-16.22 83.88-16.22 83.88 0ZM81.58-19.24L81.58-21.54 83.88-21.54 83.88-19.24 81.58-19.24ZM90.76-16.22L90.76-16.22 100.49-16.22Q101.91-16.22 102.91-15.23 103.9-14.24 103.9-12.84L103.9-12.84 103.9-3.38Q103.9-1.99 102.91-0.99 101.91 0 100.49 0L100.49 0 90.76 0Q89.36 0 88.36-0.99 87.37-1.99 87.37-3.38L87.37-3.38 87.37-12.84Q87.37-14.24 88.36-15.23 89.36-16.22 90.76-16.22ZM100.49-13.93L100.49-13.93 90.76-13.93Q90.31-13.93 89.99-13.61 89.66-13.28 89.66-12.84L89.66-12.84 89.66-3.38Q89.66-2.94 89.99-2.61 90.31-2.29 90.76-2.29L90.76-2.29 100.49-2.29Q100.94-2.29 101.26-2.61 101.58-2.94 101.58-3.38L101.58-3.38 101.58-12.84Q101.58-13.28 101.26-13.61 100.94-13.93 100.49-13.93ZM106.39-16.22L119.53-16.22Q120.93-16.22 121.93-15.23 122.92-14.24 122.92-12.84L122.92-12.84 122.92 0 120.62 0 120.62-12.84Q120.62-13.28 120.3-13.61 119.98-13.93 119.53-13.93L119.53-13.93 109.8-13.93Q109.35-13.93 109.02-13.61 108.68-13.28 108.68-12.84L108.68-12.84 108.68 0 106.39 0 106.39-16.22Z",
    transform: "translate(-1.5699999332427979, 21.540000915527344)",
    strokeWidth: 0.2,
    strokeLinejoin: "round"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "",
    className: "tp-slogan iconsvg-slogansvg",
    fill: "#000000",
    transform: "translate(5,31.842138290405273)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    height: 1,
    y: 4.820000171661377,
    width: 33.550628662109375
  }), /*#__PURE__*/React.createElement("rect", {
    height: 1,
    y: 4.820000171661377,
    width: 33.550628662109375,
    x: 162.25062561035156
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.550628662109375,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.08-7.87L1.08 0L3.10 0C3.69 0 4.21-0.09 4.67-0.27C5.12-0.45 5.51-0.71 5.82-1.05C6.13-1.39 6.37-1.81 6.53-2.30C6.69-2.79 6.77-3.35 6.77-3.97C6.77-5.23 6.45-6.19 5.82-6.86C5.19-7.54 4.26-7.87 3.05-7.87ZM2.98-0.82L2.08-0.82L2.08-7.06L2.98-7.06C3.90-7.06 4.59-6.79 5.05-6.26C5.51-5.74 5.74-4.97 5.74-3.97C5.74-2.97 5.51-2.20 5.05-1.64C4.59-1.09 3.90-0.82 2.98-0.82ZM8.46-7.87L8.46 0L9.46 0L9.46-7.87ZM11.62-7.87L11.62 0L12.56 0L12.56-4.12C12.56-4.53 12.55-4.95 12.52-5.36C12.49-5.77 12.46-6.18 12.43-6.58L12.48-6.58L13.33-4.96L16.19 0L17.22 0L17.22-7.87L16.27-7.87L16.27-3.80C16.27-3.39 16.29-2.97 16.31-2.54C16.34-2.11 16.37-1.70 16.39-1.30L16.34-1.30L15.49-2.93L12.65-7.87ZM21.80-7.87L21.80 0L22.80 0L22.80-3.12L24.22-3.12C24.65-3.12 25.04-3.17 25.40-3.27C25.75-3.37 26.06-3.52 26.32-3.72C26.57-3.92 26.77-4.17 26.91-4.48C27.05-4.78 27.12-5.14 27.12-5.56C27.12-5.99 27.05-6.35 26.91-6.65C26.77-6.94 26.57-7.18 26.32-7.36C26.07-7.54 25.76-7.67 25.40-7.75C25.04-7.83 24.65-7.87 24.22-7.87ZM24.10-3.94L22.80-3.94L22.80-7.07L24.10-7.07C24.78-7.07 25.28-6.96 25.62-6.74C25.96-6.52 26.12-6.12 26.12-5.56C26.12-5.00 25.96-4.59 25.63-4.33C25.29-4.07 24.78-3.94 24.10-3.94ZM28.72-7.87L28.72 0L33.37 0L33.37-0.85L29.71-0.85L29.71-3.71L32.70-3.71L32.70-4.56L29.71-4.56L29.71-7.03L33.25-7.03L33.25-7.87ZM35.04-7.87L35.04 0L35.99 0L35.99-4.12C35.99-4.53 35.97-4.95 35.95-5.36C35.92-5.77 35.89-6.18 35.86-6.58L35.90-6.58L36.76-4.96L39.61 0L40.64 0L40.64-7.87L39.70-7.87L39.70-3.80C39.70-3.39 39.71-2.97 39.74-2.54C39.77-2.11 39.79-1.70 39.82-1.30L39.77-1.30L38.92-2.93L36.07-7.87ZM42.83-1.72L42.23-1.02C42.57-0.66 42.98-0.38 43.45-0.17C43.92 0.04 44.44 0.14 44.99 0.14C45.40 0.14 45.78 0.09 46.10-0.03C46.43-0.15 46.71-0.31 46.94-0.51C47.18-0.71 47.35-0.95 47.48-1.22C47.60-1.50 47.66-1.79 47.66-2.10C47.66-2.39 47.62-2.64 47.54-2.86C47.45-3.08 47.34-3.27 47.20-3.44C47.05-3.60 46.88-3.75 46.68-3.87C46.48-3.99 46.27-4.10 46.04-4.20L44.93-4.68C44.77-4.74 44.61-4.81 44.46-4.89C44.31-4.97 44.17-5.05 44.04-5.15C43.91-5.25 43.81-5.37 43.73-5.50C43.66-5.63 43.62-5.80 43.62-5.99C43.62-6.35 43.75-6.63 44.02-6.83C44.29-7.04 44.64-7.14 45.08-7.14C45.45-7.14 45.78-7.07 46.07-6.94C46.37-6.81 46.63-6.63 46.87-6.40L47.41-7.04C47.13-7.33 46.79-7.57 46.39-7.75C45.99-7.93 45.56-8.02 45.08-8.02C44.72-8.02 44.39-7.96 44.09-7.86C43.79-7.76 43.53-7.61 43.31-7.42C43.09-7.23 42.92-7.01 42.80-6.76C42.67-6.50 42.61-6.22 42.61-5.93C42.61-5.64 42.66-5.39 42.76-5.17C42.85-4.95 42.98-4.76 43.13-4.60C43.28-4.44 43.45-4.30 43.64-4.19C43.84-4.08 44.02-3.98 44.21-3.90L45.34-3.41C45.52-3.32 45.69-3.24 45.85-3.16C46.01-3.08 46.15-2.99 46.27-2.89C46.38-2.79 46.47-2.67 46.54-2.53C46.61-2.39 46.64-2.22 46.64-2.02C46.64-1.63 46.50-1.32 46.21-1.09C45.92-0.85 45.52-0.73 45.00-0.73C44.59-0.73 44.20-0.82 43.82-1.00C43.44-1.18 43.11-1.42 42.83-1.72ZM49.21-7.87L49.21 0L50.21 0L50.21-7.87ZM55.27 0.14C55.77 0.14 56.22 0.05 56.63-0.14C57.05-0.34 57.40-0.61 57.70-0.97C58.00-1.32 58.23-1.75 58.40-2.26C58.56-2.77 58.64-3.34 58.64-3.97C58.64-4.60 58.56-5.16 58.40-5.66C58.23-6.16 58.00-6.58 57.70-6.93C57.40-7.28 57.05-7.55 56.63-7.73C56.22-7.92 55.77-8.02 55.27-8.02C54.78-8.02 54.32-7.92 53.91-7.74C53.50-7.56 53.14-7.29 52.85-6.94C52.55-6.59 52.32-6.17 52.16-5.67C51.99-5.17 51.91-4.60 51.91-3.97C51.91-3.34 51.99-2.77 52.16-2.26C52.32-1.75 52.55-1.32 52.85-0.97C53.14-0.61 53.50-0.34 53.91-0.14C54.32 0.05 54.78 0.14 55.27 0.14ZM55.27-0.73C54.92-0.73 54.60-0.81 54.32-0.96C54.03-1.11 53.79-1.33 53.59-1.61C53.38-1.90 53.22-2.24 53.11-2.63C53.00-3.03 52.94-3.48 52.94-3.97C52.94-4.46 53.00-4.90 53.11-5.29C53.22-5.68 53.38-6.02 53.59-6.29C53.79-6.56 54.03-6.77 54.32-6.92C54.60-7.07 54.92-7.14 55.27-7.14C55.62-7.14 55.94-7.07 56.23-6.92C56.51-6.77 56.75-6.56 56.96-6.29C57.16-6.02 57.32-5.68 57.43-5.29C57.54-4.90 57.60-4.46 57.60-3.97C57.60-3.48 57.54-3.03 57.43-2.63C57.32-2.24 57.16-1.90 56.96-1.61C56.75-1.33 56.51-1.11 56.23-0.96C55.94-0.81 55.62-0.73 55.27-0.73ZM60.34-7.87L60.34 0L61.28 0L61.28-4.12C61.28-4.53 61.27-4.95 61.24-5.36C61.21-5.77 61.18-6.18 61.15-6.58L61.20-6.58L62.05-4.96L64.91 0L65.94 0L65.94-7.87L64.99-7.87L64.99-3.80C64.99-3.39 65.01-2.97 65.03-2.54C65.06-2.11 65.09-1.70 65.11-1.30L65.06-1.30L64.21-2.93L61.37-7.87ZM68.12-1.72L67.52-1.02C67.87-0.66 68.28-0.38 68.75-0.17C69.22 0.04 69.73 0.14 70.28 0.14C70.70 0.14 71.07 0.09 71.40-0.03C71.73-0.15 72.01-0.31 72.24-0.51C72.47-0.71 72.65-0.95 72.77-1.22C72.90-1.50 72.96-1.79 72.96-2.10C72.96-2.39 72.92-2.64 72.83-2.86C72.75-3.08 72.64-3.27 72.49-3.44C72.35-3.60 72.18-3.75 71.98-3.87C71.78-3.99 71.56-4.10 71.34-4.20L70.22-4.68C70.06-4.74 69.91-4.81 69.76-4.89C69.60-4.97 69.46-5.05 69.34-5.15C69.21-5.25 69.11-5.37 69.03-5.50C68.95-5.63 68.92-5.80 68.92-5.99C68.92-6.35 69.05-6.63 69.32-6.83C69.59-7.04 69.94-7.14 70.38-7.14C70.75-7.14 71.08-7.07 71.37-6.94C71.66-6.81 71.93-6.63 72.17-6.40L72.71-7.04C72.43-7.33 72.09-7.57 71.69-7.75C71.29-7.93 70.85-8.02 70.38-8.02C70.02-8.02 69.69-7.96 69.39-7.86C69.09-7.76 68.83-7.61 68.61-7.42C68.39-7.23 68.22-7.01 68.09-6.76C67.97-6.50 67.91-6.22 67.91-5.93C67.91-5.64 67.96-5.39 68.05-5.17C68.15-4.95 68.27-4.76 68.42-4.60C68.58-4.44 68.75-4.30 68.94-4.19C69.13-4.08 69.32-3.98 69.50-3.90L70.63-3.41C70.82-3.32 70.99-3.24 71.15-3.16C71.31-3.08 71.45-2.99 71.56-2.89C71.68-2.79 71.77-2.67 71.84-2.53C71.91-2.39 71.94-2.22 71.94-2.02C71.94-1.63 71.80-1.32 71.51-1.09C71.22-0.85 70.82-0.73 70.30-0.73C69.89-0.73 69.49-0.82 69.11-1.00C68.73-1.18 68.40-1.42 68.12-1.72ZM75.50-4.14L75.50-7.07L76.82-7.07C77.44-7.07 77.91-6.96 78.24-6.76C78.57-6.55 78.73-6.18 78.73-5.66C78.73-5.15 78.57-4.77 78.24-4.52C77.91-4.27 77.44-4.14 76.82-4.14ZM78.83 0L79.96 0L77.96-3.43C78.50-3.57 78.93-3.82 79.25-4.19C79.57-4.56 79.73-5.05 79.73-5.66C79.73-6.07 79.66-6.42 79.52-6.70C79.39-6.98 79.20-7.20 78.95-7.38C78.71-7.56 78.42-7.68 78.08-7.76C77.74-7.83 77.37-7.87 76.97-7.87L74.51-7.87L74.51 0L75.50 0L75.50-3.32L76.93-3.32ZM84.71-3.20L82.34-3.20L82.72-4.40C82.86-4.84 83.00-5.28 83.12-5.72C83.25-6.15 83.38-6.60 83.50-7.06L83.54-7.06C83.67-6.60 83.80-6.15 83.93-5.72C84.06-5.28 84.19-4.84 84.34-4.40ZM84.96-2.40L85.70 0L86.77 0L84.11-7.87L82.98-7.87L80.32 0L81.34 0L82.09-2.40ZM83.53-8.39C83.85-8.39 84.12-8.48 84.33-8.67C84.54-8.86 84.65-9.12 84.65-9.44C84.65-9.76 84.54-10.02 84.33-10.21C84.12-10.40 83.85-10.50 83.53-10.50C83.20-10.50 82.94-10.40 82.73-10.21C82.52-10.02 82.42-9.76 82.42-9.44C82.42-9.12 82.52-8.86 82.73-8.67C82.94-8.48 83.20-8.39 83.53-8.39ZM83.53-8.82C83.37-8.82 83.24-8.87 83.12-8.98C83.01-9.09 82.96-9.24 82.96-9.44C82.96-9.63 83.01-9.78 83.12-9.89C83.24-10.00 83.37-10.06 83.53-10.06C83.68-10.06 83.82-10.00 83.93-9.89C84.04-9.78 84.10-9.63 84.10-9.44C84.10-9.24 84.04-9.09 83.93-8.98C83.82-8.87 83.68-8.82 83.53-8.82ZM87.89-7.87L87.89 0L89.90 0C90.50 0 91.02-0.09 91.48-0.27C91.93-0.45 92.32-0.71 92.63-1.05C92.94-1.39 93.18-1.81 93.34-2.30C93.50-2.79 93.58-3.35 93.58-3.97C93.58-5.23 93.26-6.19 92.63-6.86C92.00-7.54 91.07-7.87 89.86-7.87ZM89.78-0.82L88.88-0.82L88.88-7.06L89.78-7.06C90.70-7.06 91.39-6.79 91.85-6.26C92.31-5.74 92.54-4.97 92.54-3.97C92.54-2.97 92.31-2.20 91.85-1.64C91.39-1.09 90.70-0.82 89.78-0.82ZM94.81-3.94C94.81-3.30 94.90-2.72 95.08-2.21C95.25-1.71 95.50-1.28 95.81-0.93C96.12-0.58 96.49-0.32 96.92-0.13C97.36 0.05 97.83 0.14 98.35 0.14C98.88 0.14 99.35 0.06 99.77-0.11C100.19-0.29 100.53-0.50 100.79-0.77L100.79-4.08L98.21-4.08L98.21-3.25L99.88-3.25L99.88-1.20C99.72-1.06 99.51-0.94 99.26-0.86C99.01-0.77 98.74-0.73 98.46-0.73C98.04-0.73 97.66-0.81 97.34-0.96C97.01-1.11 96.74-1.33 96.52-1.61C96.30-1.89 96.13-2.23 96.02-2.62C95.90-3.02 95.84-3.46 95.84-3.96C95.84-4.45 95.91-4.89 96.03-5.28C96.15-5.67 96.33-6.01 96.55-6.28C96.78-6.56 97.05-6.77 97.37-6.92C97.69-7.07 98.05-7.14 98.45-7.14C98.85-7.14 99.18-7.07 99.44-6.93C99.70-6.79 99.93-6.62 100.13-6.41L100.69-7.04C100.46-7.28 100.16-7.51 99.80-7.71C99.43-7.91 98.98-8.02 98.44-8.02C97.91-8.02 97.42-7.92 96.98-7.73C96.54-7.55 96.16-7.28 95.84-6.92C95.51-6.57 95.26-6.14 95.08-5.64C94.90-5.14 94.81-4.57 94.81-3.94ZM102.67-7.87L102.67 0L103.67 0L103.67-7.87ZM104.75-7.87L107.27 0L108.43 0L110.93-7.87L109.91-7.87L108.65-3.62C108.51-3.15 108.39-2.72 108.28-2.32C108.16-1.92 108.04-1.48 107.89-1.02L107.84-1.02C107.69-1.48 107.56-1.92 107.45-2.32C107.35-2.72 107.22-3.15 107.08-3.62L105.82-7.87ZM112.01-7.87L112.01 0L116.66 0L116.66-0.85L113.00-0.85L113.00-3.71L115.99-3.71L115.99-4.56L113.00-4.56L113.00-7.03L116.54-7.03L116.54-7.87ZM119.33-4.14L119.33-7.07L120.65-7.07C121.26-7.07 121.74-6.96 122.06-6.76C122.39-6.55 122.56-6.18 122.56-5.66C122.56-5.15 122.39-4.77 122.06-4.52C121.74-4.27 121.26-4.14 120.65-4.14ZM122.65 0L123.78 0L121.79-3.43C122.32-3.57 122.75-3.82 123.07-4.19C123.39-4.56 123.55-5.05 123.55-5.66C123.55-6.07 123.48-6.42 123.35-6.70C123.21-6.98 123.02-7.20 122.78-7.38C122.53-7.56 122.24-7.68 121.90-7.76C121.56-7.83 121.19-7.87 120.79-7.87L118.33-7.87L118.33 0L119.33 0L119.33-3.32L120.76-3.32Z",
    transform: "translate(-1.08, 10.5)"
  })))))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.61dbd5d4bbaa49199008a633f921dfd7.svg";
export { ForwardRef as ReactComponent };